import { StreamPlainObject } from '../plainObjects/stream.plainObject';
import { MAP_COLUMN_CONSTANT, PARTITION_FUNCTION_CONSTANT } from '../constants';
import { ExecuteFlowletPlainObject } from '../plainObjects/executeFlowlet.plainObject';
import { ColumnMapVisitor } from './columnMap.visitor';
import { ColumnMappingPlainObject } from '../plainObjects/columnMappingBase.plainObject';
import { MatchFunctionUtil } from '../utils/matchFunction.util';

/* eslint-disable @typescript-eslint/no-explicit-any */
export class ExecuteFlowletVisitor extends ColumnMapVisitor {
    private inputOrder: number = -1;
    private get _executeFlowletTransformation(): ExecuteFlowletPlainObject {
        return this.transformation as ExecuteFlowletPlainObject;
    }

    public visitTransformation(transformationContext: any): void {
        transformationContext.expression().forEach((expression: any) => {
            if (expression.basicFunction && expression.getText().startsWith(PARTITION_FUNCTION_CONSTANT)) {
                this.visit(expression);
            } else if (expression.getText().startsWith(MAP_COLUMN_CONSTANT)) {
                this.inputOrder++;
            }
            this.visit(expression);
        });
        const configurationList = transformationContext.configuration();
        if (configurationList && configurationList.length > 0) {
            (configurationList as any[]).forEach((configuration) => {
                if (this._getText(configuration.configName() as string) === 'composition') {
                    this._executeFlowletTransformation.composition = this._getText(configuration.getChild(2));
                }
            });
        }
    }

    public visitOutputTransformed(outputTransformedContext: any): void {
        this._executeFlowletTransformation.name = this._getText(outputTransformedContext.children[0]);
        const outputStreams = outputTransformedContext.groupName();
        outputStreams.forEach((child: any, index: number) => {
            const streamName = this.visitTransformed(child);
            this._executeFlowletTransformation.outputStreams.push(new StreamPlainObject(streamName));
        });
    }

    public visitMetaFunctionExpr(context: any): void {
        if (context.metafunction().basicName().getText() === 'mapParameter') {
            MatchFunctionUtil.addParameterValues(this._executeFlowletTransformation, context.metafunction());
        } else {
            super.visitMetaFunctionExpr(context);
        }
    }

    protected _addColumnPlaceholder(aliasName: string, actualColumnName: string, isField?: boolean, isArraySelector?: boolean): void {
        const mapping = new ColumnMappingPlainObject();
        mapping.name = actualColumnName;
        mapping.alias = aliasName;
        mapping.isField = isField;
        mapping.isArraySelector = isArraySelector;

        if (this._executeFlowletTransformation.mappings.has(this.inputOrder)) {
            this._executeFlowletTransformation.mappings.get(this.inputOrder).push(mapping);
        } else {
            this._executeFlowletTransformation.mappings.set(this.inputOrder, [mapping]);
        }
    }
}
